export default String.raw`
{% assign banner = config.Banners[include] -%}
{% assign bannerImagesSize = banner.Images | Size -%}

{% if bannerImagesSize > 0 -%}
    {% assign bannerPopup = banner.Images[0] -%}
    <dialog class="popupBanner dialog popup-timer-js">
        <div class="popupBanner__body">
            <form method="dialog" class="popupBanner__body-close">
                <button aria-label="{{ translations.Close }}" class="close-js">
                    <svg aria-hidden="true">
                        <use href='css/img/fontawesome-icons.svg?v={{lqTS}}#times-{{ settings.iconStyle }}'></use>
                    </svg>
                </button>
            </form>
            {% if bannerPopup.Heading != "" -%}
                <div class="popupBanner__body-header">
                    <h2>
                        {{ bannerPopup.Heading }}
                    </h2>
                </div>
            {% endif -%}
            <div class="popupBanner__body-image">
                {% if bannerPopup.Link != "" -%}
                    {% capture bannerPopupHref -%}{% include 'partials/common/user-link.html', userLink: bannerPopup.Link -%}{% endcapture -%}
                    <a href="{{ bannerPopupHref }}" {% if bannerPopup.TargetBlank == true -%} target="blank" {% endif -%}>
                {% endif -%}
                        <img src="css/img/alo.gif" data-src="{{ bannerPopup.Url }}" alt="{{ bannerPopup.Alt | H}}" title="{{bannerPopup.Title | H}}" loading="eager" fetchpriority="high">
                {% if bannerPopup.Link != "" -%}
                    </a>
                {% endif -%}
            </div>
            {% if bannerPopup.Link != '' or bannerPopup.Text != '' -%}
                <div class="popupBanner__body-content">
                    {% if bannerPopup.Text != "" -%}
                        <p>
                            {{ bannerPopup.Text }}
                        </p>
                    {% endif -%}
                    {% if bannerPopup.Link != "" -%}
                        {% capture bannerPopupHref -%}{% include 'partials/common/user-link.html', userLink: bannerPopup.Link -%}{% endcapture -%}
                        <a class="primary-action-button popupBanner__body-content-button" href="{{ bannerPopupHref }}" {% if bannerPopup.TargetBlank == true -%} target="blank" {% endif -%}>
                            <span>
                                {{ translations.Check }}
                            </span>
                        </a>
                    {% endif -%}
                    <form method="dialog" class="popupBanner__body-content-close">
                        <button class="pure-button close-js">
                            <span>
                                {{ translations.Close }}
                            </span>
                        </button>
                    </form>
                </div>
            {% endif -%}
        </div>
    </dialog>
{% endif -%}
`